<template>
  <PageListLayout @reset-filter="resetFilter">
    <template slot="header_right">
      <v-list-item three-line>
        <v-layout align-center>
          <v-img
            max-height="150"
            max-width="150"
            :src="BaoCaoPic"
            class="mr-4"
          ></v-img>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1 black--text">
              BÁO CÁO HỆ THỐNG</v-list-item-title
            >
            <v-list-item-subtitle
              >Báo cáo tăng trưởng thị phần</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-layout>
      </v-list-item>
      <div class="d-flex">
        <v-tooltip>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-1 mt-12" icon v-on="on" @click="exportExcel()">
              <v-icon> mdi-file-export-outline </v-icon>
            </v-btn>
          </template>
          <span>Xuất Excel</span>
        </v-tooltip>
      </div>
    </template>
    <template slot="filter">
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.year"
          placeholder="Chọn năm"
          auto-select-first
          :items="years"
          outlined
          solo
          dense
          hide-details="auto"
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.month"
          :items="this.monthList"
          placeholder="Chọn tháng"
          item-text="name"
          item-value="id"
          solo
          outlined
          dense
          hide-details="auto"
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.nhan_vien_id"
          :items="employers"
          placeholder="Nhân viên phụ trách"
          item-text="name"
          item-value="id"
          multiple
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.area_id"
          :items="areasData"
          placeholder="khu vực"
          item-text="name"
          item-value="id"
          multiple
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </div>
    </template>
    <CustomTable
      :headers="headers"
      :items="dataTable"
      :page.sync="page"
      :items-per-page="50"
      :loading="isloading"
      hide-default-footer
      @change-page="changePage"
      classPaging="mt-2"
    ></CustomTable>
  </PageListLayout>
</template>
<script>
import BaoCaoPic from "../../../assets/images/baocao.svg";
import { monthList } from "@/constants/time";
import Report from "@/api/report.js";
import { generateArrayOfYears } from "@/utils/date.js";
import { getAllAreas } from "@/api/khuvuc";
import { getNhanVienKinhDoanh } from "@/api/nhanvien";

import { saveAs } from "file-saver";
export default {
  data() {
    return {
      page: 1,
      BaoCaoPic,
      isloading: false,
      search: "",
      calories: "",
      items: [],
      headers: [
        {
          text: "Năm",
          value: "year",
          align: "start",
          filter: (value) => {
            if (!this.calories) return true;
            return value < parseInt(this.calories);
          },
        },
        { text: "Tháng", value: "month" },
        { text: "Nhân viên", value: "nhan_vien" },
        { text: "Khu vực", value: "area" },
        {
          text: "Nhóm khách hàng",
          value: "type",
        },
        {
          text: "Tổng số lượng khách hàng đang phục vụ trong kì",
          value: "served_during_the_period",
        },
        // {
        //   text: "Tổng số lượng khách hàng phát sinh giao dịch trong kỳ",
        //   value: "contract_new_transaction",
        // },
        {
          text: "Tổng số khách hàng cần tái kí hợp đồng",
          value: "need_renew_contract",
        },

        {
          text: "Số khách hàng kí gia hạn hợp đồng",
          value: "contract_sign_extend",
        },

        { text: "Số lượng khách hàng kí mới", value: "new_customers" },
        {
          text: "Số lượng khách hàng mới phát sinh dao dịch trong kì",
          value: "contract_new_transaction",
        },
        {
          text: "Số lượng khách hàng mục tiêu kí mới",
          value: "customer_register",
        },
        {
          text: "Số lượng khách hàng mục tiêu đã tiếp cận trong kì",
          value: "customer_accost",
        },
        {
          text: "Số lượng khách hàng mục tiêu chưa tiếp cận",
          value: "customer_new",
        },
        {
          text: "Tỷ lệ khách hàng ký mới phát sinh giao dịch trong kì",
          value: "ration_new_customers_transaction",
        },
        {
          text: "Số lượng khách hàng không tái ký/gia hạn hợp đồng",
          value: "customer_no_renew_contract",
        },
        {
          text: " Tỷ lệ khách hàng tái kí, gia hạn hợp đồng",
          value: "ration_sign_extend",
        },
      ],
      data: {},
      data_render: [],
      desserts: [],
      monthList,
      years: generateArrayOfYears(10),
      areasData: [],
      employers: [],
      formSearch: {
        year: new Date().getFullYear(),
        month: "",
        nhan_vien_id: [],
        area_id: [],
      },
    };
  },
  computed: {
    dataTable() {
      return this.items.filter((item) => item.show);
    },
  },
  created() {
    this.isloading = true;
    this.getAllEmployee();
    this.getAllArea();
    this.getData();
    this.isloading = false;
  },
  watch: {
    formSearch: {
      handler: function (newValue) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    changePage(val) {
      this.page = val;
    },
    async getAllEmployee() {
      try {
        const res = await getNhanVienKinhDoanh();
        this.employers = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getAllArea() {
      let data = await getAllAreas();
      this.areasData = data;
    },
    async getData() {
      try {
        this.isloading = true;
        const res = await Report.getReportCustomer(this.formSearch);
        var d = res.data;
        if (this.formSearch.area_id.length > 0) {
          let array = this.formSearch.area_id;
          d = res.data.filter(function (e) {
            return array.includes(e.area_id);
          });
        }

        if (this.formSearch.nhan_vien_id.length > 0) {
          let array = this.formSearch.nhan_vien_id;
          d = res.data.filter(function (e) {
            return array.includes(e.nhan_vien_id);
          });
        }
        d.forEach(function(item){
          if(item.nhan_vien != null ){
            item.nhan_vien = item.nhan_vien.split(' ').slice(-1).join(' ');
          }
          if(item.customer_register == null ){
            item.customer_register = 0
          }
          if(item.customer_accost == null ){
            item.customer_accost = 0
          }
          if(item.customer_new == null ){
            item.customer_new = 0
          }
        });
        this.items = d.map((x) => ({ ...x, show: true }));
        this.isloading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async exportExcel() {
      try {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        let newdate = day + "/" + month + "/" + year;

        const res = await Report.exportReportCustomer(this.formSearch);    

        if (res && res.isDone) {
          saveAs(new Blob([res.data]), "BaoCaoThiPhan"+"-"+newdate+".xlsx");

          this.$toast.success("Xuất báo cáo thành công", {
            position: "top-center",
            timeout: 2000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
          });
        }
      } catch (error) {
        this.$toast.error("lỗi" + " " + error, {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          message: error,
        });
      }
    },
    resetFilter() {
      this.formSearch = this.$options.data.call(this).formSearch;
    },
  },
};
</script>

<style>
.app {
  margin-top: 10px;
}
</style>